import {
  categorySpecificData,
  ColorData,
  ProductImageGroups,
} from "store/product/ProductTypes";

export const FETCH_FREQUENT_BOUGHT_TOGETHER_PRODUCTS = {
  REQUEST: "FETCH_FREQUENT_BOUGHT_TOGETHER_PRODUCTS_REQUEST",
  SUCCESS: "FETCH_FREQUENT_BOUGHT_TOGETHER_PRODUCTS_SUCCESS",
  FAILURE: "FETCH_FREQUENT_BOUGHT_TOGETHER_PRODUCTS_FAILURE",
};

export const RESET_FREQ_BOUGHT_TOGETHER_PRODUCTS =
  "RESET_FREQ_BOUGHT_TOGETHER_PRODUCTS";

export const LOAD_PRODUCT_DETAILS_FOR_FREQ_PRODUCTS =
  "LOAD_PRODUCT_DETAILS_FOR_FREQ_PRODUCTS";
export const FETCH_PRODUCTS_DETAILS_FOR_FREQ_PRODUCTS = {
  START: "FETCH_PRODUCTS_DETAILS_FOR_FREQ_PRODUCTS_START",
  REQUEST: "FETCH_PRODUCTS_DETAILS_FOR_FREQ_PRODUCTS_REQUEST",
  SUCCESS: "FETCH_PRODUCTS_DETAILS_FOR_FREQ_PRODUCTS_SUCCESS",
  FAILURE: "FETCH_PRODUCTS_DETAILS_FOR_FREQ_PRODUCTS_FAILURE",
  STOP: "FETCH_PRODUCTS_DETAILS_FOR_FREQ_PRODUCTS_STOP",
};

export const GET_FREQ_BOUGHT_TOGETHER_LIST = "GET_FREQ_BOUGHT_TOGETHER_LIST";

export const FETCH_TRENDING_PRODUCTS = {
  REQUEST: "FETCH_TRENDING_PRODUCTS_REQUEST",
  SUCCESS: "FETCH_TRENDING_PRODUCTS_SUCCESS",
  FAILURE: "FETCH_TRENDING_PRODUCTS_FAILURE",
};

export const FETCH_BESTSELLERS_PRODUCTS = {
  REQUEST: "FETCH_BESTSELLERS_PRODUCTS_REQUEST",
  SUCCESS: "FETCH_BESTSELLERS_PRODUCTS_SUCCESS",
  FAILURE: "FETCH_BESTSELLERS_PRODUCTS_FAILURE",
};

export const GET_BESTSELLERS_PROD_LIST = "GET_BESTSELLERS_LIST";
export const GET_TRENDING_PROD_LIST = "GET_TRENDING_LIST";
export const RESET_GLOBAL_RECOMMENDATIONS_LIST =
  "RESET_GLOBAL_RECOMMENDATIONS_LIST";

export const FETCH_PRODUCT_IDS_BY_CODES = {
  REQUEST: "FETCH_PRODUCT_IDS_BY_CODES_REQUEST",
  SUCCESS: "FETCH_PRODUCT_IDS_BY_CODES_SUCCESS",
  FAILURE: "FETCH_PRODUCT_IDS_BY_CODES_FAILURE",
};

export const GET_PRODUCT_IDS_BY_CODES = "GET_PRODUCT_IDS_BY_CODES";

export const UPDATE_STATE_PRODUCT_DATA = "UPDATE_STATE_PRODUCT_DATA";

export const UPDATE_PRODUCT_DETAILS_FETCHED = "UPDATE_PRODUCT_DETAILS_FETCHED";

export interface getFreqBoughtTogetherPayload {
  productId: string;
  limit: number;
  period: number;
  isProductIdAnalyticIdAPIAvailable: boolean;
}

export interface getGlobalRecommendationPayload {
  limit: number;
  period: number;
  isProductIdAnalyticIdAPIAvailable: boolean;
}

export interface freqBoughtTogetherList {
  productCode: string;
}

export interface GlobalRecommendationList {
  productCode: string;
}

export interface FreqBoughtTogetherAction {
  type: typeof GET_FREQ_BOUGHT_TOGETHER_LIST;
  payload: {
    productId: string;
    limit: number;
    period: number;
    isProductIdAnalyticIdAPIAvailable: boolean;
  };
}

export interface ProductListAction<T extends string> {
  type: T;
  payload: {
    limit: number;
    period: number;
    isProductIdAnalyticIdAPIAvailable: boolean;
  };
}

export interface TrendingProductAction
  extends ProductListAction<typeof GET_TRENDING_PROD_LIST> {}

export interface BestsellersProductAction
  extends ProductListAction<typeof GET_BESTSELLERS_PROD_LIST> {}

export interface GetProductListPayload {
  catalogId: string;
  categoryId: string;
  localeCode: string | null;
  storeId: string;
  next?: string;
  count?: number;
  productIds?: string[];
  totalPagesFetched?: Number;
  isRefreshingAllProducts?: boolean;
  isCatalogIdRequired?: boolean;
}

export interface loadProductsForFreqProductsAction {
  payload: GetProductListPayload;
  type: typeof LOAD_PRODUCT_DETAILS_FOR_FREQ_PRODUCTS;
}

export interface ProductItem {
  productCode: string;
  productName: string;
  [key: string]: any;
}

export interface FreqBoughtProductData {
  isRefreshing?: boolean;
  cachedAt?: Date;
  productId?: string;
  code: string;
  analyticsId?: string;
  type?: string;
  colorId?: string;
  name?: string;
  swatchImage?: string;
  baseProductId?: string | undefined;
  thumbnail?: string;
  isPublished?: boolean;
  storeSpecific?:
    | { storeId: string; isPublished: boolean | null }[]
    | undefined;
  translations?: [
    {
      localeCode: string;
      name: string;
    },
  ];
  stock?: number;
  hasSequenceableColors?: boolean;
  price?: Number;
  bounds?: ClientRect | DOMRect | null;
  isUpdatingPublishFlag?: boolean;
  lowPrice?: number;
  listPrice?: number;
  highPrice?: number;
  typeCode?: string;
  stockValue?: number;
  categorySpecific?: categorySpecificData[];
  colors?: ColorData[];
  imageGroups?: ProductImageGroups[];
  colorVariationAttributeId?: string;
}

export interface ProductCodeToIdPayload {
  productCodes: string[];
  catalogId: string;
  storeId: string;
  localeCode: string | null;
}

export interface ProductIdCodeMapping {
  productId: string | null;
  code: string;
}

export interface FetchProductIdsByCodesAction {
  type: typeof GET_PRODUCT_IDS_BY_CODES;
  payload: ProductCodeToIdPayload;
}

export interface UpdateStateProductDataPayload {
  products: {
    productCode: string;
  }[];
  recommendationType: string;
}
export interface UpdateStateProductDataAction {
  type: typeof UPDATE_STATE_PRODUCT_DATA;
  payload: UpdateStateProductDataPayload;
}
